export enum LiveCompanyEnum {
  usePlanCk = 1,
  usePlanNotCk = 2
}
